import useAllViewerShops from "@babackapp/private-api-client/client/use-all-viewer-shops";
import { useSuperAdminAllShops } from "@babackapp/private-api-client/client/use-super-admin-all-shops";
import { useSuperAdminConfig } from "@babackapp/private-api-client/client/use-super-admin-shops";
import { Navigate } from "react-router-dom";
import { HomeLoading } from "@/components/home-loading";
import { pickLandingShopId, readLastShop } from "@/lib/shop/landing-shop";
import { useViewerIsSuperAdmin } from "@/lib/rights/use-viewer-is-baback-team";
import { NoShopFound } from "./components/no-shop-found";

export default function ShopsPage() {
	const { data: shops, isPending } = useAllViewerShops();
	// A super admin is no member of the shops they support (BAB-3035): they land
	// on the default shop set on the Super admins page, else the last one
	// opened, else the first live shop.
	const isSuperAdmin = useViewerIsSuperAdmin();
	const { data: allShops, isPending: isPendingAllShops } =
		useSuperAdminAllShops(isSuperAdmin);
	const { data: config, isPending: isPendingConfig } =
		useSuperAdminConfig(isSuperAdmin);

	if (isPending || (isSuperAdmin && (isPendingAllShops || isPendingConfig))) {
		return <HomeLoading />;
	}

	const landingShopId = pickLandingShopId(
		isSuperAdmin ? (allShops ?? shops ?? []) : (shops ?? []),
		[isSuperAdmin ? config?.superAdminDefaultShopId : null, readLastShop()],
	);
	if (!landingShopId) return <NoShopFound />;
	return <Navigate to={`/shops/${landingShopId}`} replace />;
}
